export const googleAnalyticsNormalAction = (
  eventName: string,
  category: string,
  action: string,
  label: string,
) => {
  window.dataLayer.push({
    event: eventName,
    event_category: category,
    event_action: action,
    event_label: label,
  });
};

export const googleAnalyticsQuoteButton = (
  eventName: string,
  category: string,
  action: string,
  label: string,
  destination: string,
  planType: string,
  duration: number,
) => {
  window.dataLayer.push({
    event: eventName,
    event_category: category,
    event_action: action,
    event_label: label,
    travel_destination: destination,
    traveller_type: planType,
    coverage_duration: duration,
  });
};

export const googleAnalyticsWithQuotationDetails = (
  eventName: string,
  category: string,
  action: string,
  label: string,
  priceCurrency: string,
  totalPrice: string,
  planAndAddonDetails: any,
  transactionId?: string,
) => {
  if (transactionId !== undefined) {
    window.dataLayer.push({
      event: eventName,
      event_category: category,
      event_action: action,
      event_label: label,
      ecommerce: {
        transaction_id: transactionId,
        currency: priceCurrency,
        value: totalPrice,
        items: planAndAddonDetails,
      },
    });
  } else {
    window.dataLayer.push({
      event: eventName,
      event_category: category,
      event_action: action,
      event_label: label,
      ecommerce: {
        currency: priceCurrency,
        value: totalPrice,
        items: planAndAddonDetails,
      },
    });
  }
};

export const googleAnalyticsWithEmailAndMobile = (
  eventName: string,
  category: string,
  action: string,
  label: string,
  email: string,
  mobileNumber: string,
  priceCurrency: string,
  totalPrice: string,
  planAndAddonDetails: any,
  transactionId?: string,
) => {
  if (transactionId !== undefined) {
    window.dataLayer.push({
      event: eventName,
      event_category: category,
      event_action: action,
      event_label: label,
      email,
      mobileNumber,
      ecommerce: {
        transaction_id: transactionId,
        currency: priceCurrency,
        value: totalPrice,
        items: planAndAddonDetails,
      },
    });
  } else {
    window.dataLayer.push({
      event: eventName,
      event_category: category,
      event_action: action,
      event_label: label,
      email,
      mobileNumber,
      ecommerce: {
        currency: priceCurrency,
        value: totalPrice,
        items: planAndAddonDetails,
      },
    });
  }
};

export const googleAnalyticsSuccessPage = (
  eventName: string,
  category: string,
  action: string,
  label: string,
  priceCurrency: string,
  totalPrice: string,
  planAndAddonDetails: any,
  transactionId: string,
) => {
  window.dataLayer.push({
    event: eventName,
    event_category: category,
    event_action: action,
    event_label: label,
    ecommerce: {
      transaction_id: transactionId,
      currency: priceCurrency,
      value: totalPrice,
      items: planAndAddonDetails,
    },
  });
};

export const createProductItem = (
  itemId: string,
  itemName: string,
  itemCategory: string,
  itemCategory2: string,
  itemCategory3: string,
  itemCategory4: string,
  itemCategory5: string,
  itemVariant: string,
  currency: string,
  price: string,
  quantity: string,
) => {
  return {
    item_id: itemId,
    item_name: itemName,
    item_category: itemCategory,
    item_category2: itemCategory2,
    item_category3: itemCategory3,
    item_category4: itemCategory4,
    item_category5: itemCategory5,
    item_variant: itemVariant,
    currency,
    price,
    quantity,
  };
};
